export const ICON_KINDS = ['spot', 'brand-logos'];
